export default __webpack_public_path__ + "static/a29-92712274c95a2336e95586253ee90538.png";